import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Table from "~/components/Table";
import Button from "~/shared/ui/Fields/Button";
import { useGetDealerDomainsQuery } from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { Input } from "~/shared/ui/Fields/Input";

import { DeleteModal } from "./components";
import { useManagementDomains } from "./helper";
import { DOMAIN_HEADER } from "./options";
import { getSchemaValidation } from "./validationDomainInput";

import s from "./ManageEmailDomains.less";

type ManageEmailDomainsProps = {
  dealerId: string;
  handleCloseModal: () => void;
};

type FormSubmit = {
  domain: string;
  dealerId?: string;
};

const ManageEmailDomains = ({
  dealerId,
  handleCloseModal,
}: ManageEmailDomainsProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const getData = useGetDealerDomainsQuery({
    variables: { dealerId },
    skip: !dealerId,
  });

  const tableItems = getData?.data?.DealerGetter?.getDealerDomains?.items || [];
  const refetch = getData.refetch;

  const { createDomain } = useManagementDomains();

  const { handleSubmit, control, reset, errors } = useForm({
    defaultValues: { domain: "" },
    resolver: yupResolver(getSchemaValidation()),
  });

  const onChangeDecorator = (e) => ({
    ...e,
    target: {
      ...e.target,
      value: e.target.value.replace(/@/g, ""),
    },
  });

  const onSubmit: SubmitHandler<FormSubmit> = (data) => {
    createDomain({ variables: { dealerId, domain: data.domain } })
      .then(() => {
        refetch();
        reset();
      })
      .catch((error) => console.log(error));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={s.wrapper}>
      <div className={s.table}>
        {hasPermission("dealergraph.domain.create") && (
          <div className={s.table_add}>
            <Input
              name={"domain"}
              control={control}
              label={"Домен"}
              onChangeDecorator={onChangeDecorator}
              customClassName={s.input}
              error={errors["domain"]?.message}
            />
            <Button
              isForm
              txtBtn={t("ui.add")}
              small
              customClassName={s.button}
            />
          </div>
        )}
        <Table
          type={"domains_table"}
          options={DOMAIN_HEADER}
          items={tableItems ? tableItems : []}
          sortable={false}
          btnDel={hasPermission("dealergraph.domain.delete")}
        />
      </div>
      <div className={s.buttons}>
        <Button
          txtBtn={t("ui.close")}
          small={true}
          onClick={handleCloseModal}
        />
      </div>
      <DeleteModal refetch={refetch} />
    </form>
  );
};

export default ManageEmailDomains;
